// components/NetworkErrorDialog.tsx
import { Button } from "@/components/ui/button";
import ModalPopup from "@/components/ui/modalpopup";
import { WifiOff } from "lucide-react";

const NetworkErrorDialog = ({ open, title, message, onRetry, icon }) => {
  if (!open) return null;

  return (
    <ModalPopup
      open={open}
      onClose={onRetry}
      width="w-[400px]"
      actionButton={
        <div className="flex justify-center w-full">
        <Button
          id="saveButton"
          onClick={onRetry}
        >
          ok
        </Button>
        </div>
      }
    >
      <div className="flex flex-col items-center text-center space-y-4">
        {/* Icon */}
        <div className="flex justify-center">
          {icon ? (
            icon
          ) : (
            <WifiOff className="h-12 w-12 text-primary" />
          )}
        </div>

        {/* Title */}
        {title && (
          <h2 className="font-semibold text-lg text-foreground">{title}</h2>
        )}

        {/* Message */}
        {message && (
          <p className="text-sm text-muted-foreground">{message}</p>
        )}
      </div>
    </ModalPopup>
  );
};

export default NetworkErrorDialog;
